import React from 'react';
import TenantManager from '../../../../components/tenantManager';
import tenants from './tenants';

class EditShiftsForm extends React.Component {
    render() {
        return (
            <div className="edit-shifts-form">
                <TenantManager {...tenants} {...this.props} />
            </div>
        );
    }
}

export default EditShiftsForm;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/forms/editShifts/index.jsx